import { normalisePath } from '../normalisePath';
/**
 * Has - Checks if path is a direct property of object.
 *
 * @param {Record<any, any>} obj
 * @param {(string | Array<string>)} path
 * @return {*}  {boolean}
 *
 * @example
 * has({ 'a': { 'b': 2 } }, 'a');
 * // returns true
 *
 * has({ 'a': { 'b': 2 } }, 'a');
 * // returns true
 *
 */
export var has = function (obj, path) {
    var keyParts = normalisePath(path);
    return !!obj && (keyParts.length > 1
        ? has(obj[keyParts[0]], keyParts.slice(1).join('.'))
        : Object.prototype.hasOwnProperty.call(obj, keyParts[0]));
};
//# sourceMappingURL=has.js.map